import { getProductPageUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import {
    format,
    getPayloadObject,
    getTelemetryAttributes,
    ITelemetryContent,
    onTelemetryClick,
    Button
} from '@msdyn365-commerce-modules/utilities';
import { RatingComponent, AddToWishlistComponent } from '@msdyn365-commerce/components';
import { PriceComponent } from '../custom-components/product-price-component';
import { generateImageUrl, ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Quantity } from '../../utilities/quantity';
import { IDobbiesAddedProductToBundle } from '../../../../modules/dobbies-product-collection/dobbies-product-collection';
import { CartModulesStateShareInput } from '../../../../actions/cart-state-share';
import { getCartState } from '@msdyn365-commerce/global-state';
import { getDeliveryOptionsAsync, getByIdAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { cartLineQuantityUpdatedAsync } from '@msdyn365-commerce-modules/cart-utilities';
import { ICartActionResult } from '@msdyn365-commerce/global-state';

import { getCartFromCustomer } from '@msdyn365-commerce/global-state';
import {
    IComponent,
    IComponentProps,
    ICoreContext,
    IGridSettings,
    IImageData,
    IImageSettings,
    Image,
    msdyn365Commerce,
    ICommerceApiSettings,
    RichTextComponent
} from '@msdyn365-commerce/core';
import {
    ProductPrice,
    AttributeValue,
    DiscountLine,
    Cart,
    CommerceList,
    LoyaltyCard,
    SimpleProduct,
    DeliveryOption
} from '@msdyn365-commerce/retail-proxy';
import React, { useRef, useState, useMemo, useCallback } from 'react';
import { IProductWithModes } from '../../../../modules/dobbies-search-result-container/components';
import { getAllOrgUnitLocationsByArea, GetAllOrgUnitLocationsByAreaInput } from '../../../../actions/get-all-store-location-information';
import { IFullOrgUnitAvailability } from '../../actions/utilities/full-org-unit-availability';
import { GetUnbxdAddToCartProductInput } from '../../../../actions/get-unbxd-add-to-cart-product.action';
import { GetUnbxdRemoveFromCartProductInput } from '../../../../actions/get-unbxd-remove-from-cart-product.action';
import { VsiCustomBadges } from '../custom-components/vsi-custom-badges';
import { CustomCarousel } from '../custom-components/custom-carousel';
import { IMediaData } from '../../../../modules/dobbies-media-gallery/utils/helper';
import { getOptimizedImageUrl, sanitizeImageUrl } from '../../utilities';

export interface IProductComponentProps extends IComponentProps<{ product?: IProductWithModes; discountLine?: DiscountLine }> {
    isNotificationModal?: boolean;
    isFetchingInventory?: boolean;
    className?: string;
    imageSettings?: IImageSettings;
    savingsText?: string;
    freePriceText?: string;
    originalPriceText?: string;
    currentPriceText?: string;
    ratingAriaLabel?: string;
    allowBack?: boolean;
    telemetryContent?: ITelemetryContent;
    quickViewButton?: React.ReactNode;
    inventoryLabel?: string;
    isPriceMinMaxEnabled?: boolean;
    discountLine?: DiscountLine[] | undefined;
    badgeLink?: string;
    showProdPrice?: boolean;
    showDeliveryIcons?: boolean;
    wishlists?: CommerceList[];
    isMobile?: boolean;
    showBanner?: (prodId: number) => void;
    hideBanner?: (prodId: number) => void;
    loyalty?: LoyaltyCard;
    nonClubPlusDiscount?: ProductPrice;
    isProductAddedToBundles?: boolean;
    maxQuantityForBundle?: number;
    redirectToCartEnabled?: boolean;
    isProductBundles?: boolean;
    isQuantityUpdated?: boolean;
    isBundlesModal?: boolean;
    simpleProduct?: SimpleProduct;
    isNewCarouselDesign?: boolean;
    saveForLaterHandler?: ISaveForLaterActionsHandler;
    saveForLaterQuantity?: number;
    isUnbxdWidget?: boolean;
    isOnlyStore?: boolean;
    showUnbxdAddToBasket?: boolean;
    isProductAvailable?: boolean;
    onQuantityChangeListener?(productId: number, newQuantity: number): void;
    onBundleProductCheckBoxSelected?(productId: number): void;
    removeProductFromCollection?(productId: number): void;
    moveToBasket?(productWithModes: IProductWithModes): void;
    onClickAndCollect?: (product: IProductWithModes, setExistsInCartLines: React.Dispatch<React.SetStateAction<boolean>>) => void;
    onRemoveProduct?: () => void;
    showRemoveProductButton?: boolean;
    removedProductFromCart?: number | null;
    plpFeaturesAttributeName?: string;
}

interface ILocalImgData {
    validatedImages: IImageData[];
    hasValidImages: boolean;
    isValidating?: boolean;
}

export interface ISaveForLaterActionsHandler {
    removeFromSaveForLater?(productId: number): void;
}

export interface IProductComponent extends IComponent<IProductComponentProps> {}

const PriceComponentActions = {};

const ProductCard: React.FC<IProductComponentProps> = ({
    data,
    context,
    imageSettings,
    savingsText,
    freePriceText,
    originalPriceText,
    currentPriceText,
    ratingAriaLabel,
    allowBack,
    typeName,
    id,
    telemetryContent,
    quickViewButton,
    wishlists,
    discountLine,
    badgeLink,
    showBanner,
    hideBanner,
    showDeliveryIcons = !data.product?.IsMasterProduct,
    isMobile,
    loyalty,
    nonClubPlusDiscount,
    isProductAddedToBundles,
    maxQuantityForBundle,
    redirectToCartEnabled,
    isProductBundles,
    isBundlesModal,
    isQuantityUpdated,
    simpleProduct,
    onQuantityChangeListener,
    onBundleProductCheckBoxSelected,
    isNotificationModal,
    isNewCarouselDesign,
    saveForLaterHandler,
    saveForLaterQuantity,
    removeProductFromCollection,
    moveToBasket,
    isOnlyStore,
    isUnbxdWidget,
    showUnbxdAddToBasket,
    onClickAndCollect,
    onRemoveProduct,
    showRemoveProductButton,
    removedProductFromCart,
    plpFeaturesAttributeName,
    isFetchingInventory
}) => {
    const [cartData, setCartData] = React.useState<Cart | undefined>(undefined);
    const [updatedProductPrice, setUpdatedProductPrice] = React.useState<number>();
    const [isHover, setIsHover] = useState(false); // for hover effect
    const productImageRef = useRef<HTMLDivElement>(null);
    const [currBundleQuantity, setCurrBundleQuantity] = React.useState<number>(1);
    const [carouselCurrQuantity, setCarouselCurrQuantity] = useState<number>(0);
    const [existsInCartLines, setExistsInCartLines] = useState(false);
    const [isProductAvailable, setIsProductAvailable] = useState<boolean | undefined>(false);
    const [isAddingToBasket, setIsAddingToBasket] = useState<boolean>(false);
    const [isCnCProductAvailable, setIsCnCProductAvailable] = useState<boolean | undefined>(false);
    const [isEcomProductAvailable, setIsEcomProductAvailable] = useState<boolean | undefined>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const product = data.product;

    if (!product) {
        return null;
    }

    // VSI CUSTOMIZATION - Check if current page is a category page for new design
    const isCategoryPage = (): boolean => {
        const url = context.request.url?.requestUrl.href || '';
        return /\/\d+\.c(\/)?(\?|$)/.test(url) || url.includes('search?q');
    };

    //VSI CUSTOMIZATION -START - Task 11167: PLP hover image flip
    const [images, setImages] = useState<ILocalImgData>({ validatedImages: [], hasValidImages: false, isValidating: false });
    const [isPrimaryImageValid, setIsPrimaryImageValid] = useState<boolean>(true);
    const [hasHomeDelMode, setHasHomeDelMode] = useState<boolean>(false);
    const [hasCNCMode, setHasCNCMode] = useState<boolean>(false);

    const onQChangeNewCarouselDesign = async (newValue: number) => {
        const cartState = await getCartState(context.actionContext);
        const cl = cartState.cart.CartLines?.find(c => c.ProductId === product.RecordId);
        const simpleProdResp = await getByIdAsync(
            { callerContext: context.actionContext },
            Number(product.RecordId),
            context.request.apiSettings.channelId
        );
        const simpleProd: SimpleProduct = Array.isArray(simpleProdResp) ? simpleProdResp[0] : simpleProdResp;
        if (cl) {
            if (cl?.Quantity && cl.Quantity > newValue) {
                cartLineQuantityUpdatedAsync(true, cartState, context.actionContext.telemetry, [simpleProd], cl, newValue)
                    .then((cartActionResult: ICartActionResult | undefined): boolean => {
                        if (cartActionResult?.status === 'SUCCESS') {
                            setCarouselCurrQuantity(newValue);
                        }
                        return false;
                    })
                    .catch(e => {});
            } else {
                const productList = new Array();
                const quantityToBeAdded = newValue - (cl?.Quantity ? cl?.Quantity : 0);
                productList.push({
                    product: product,
                    count: quantityToBeAdded,
                    enableStockCheck: context.app.config.enableStockCheck
                });
                cartState?.addProductsToCart(productList).then(result => {
                    if (result.status === 'SUCCESS') {
                        setCarouselCurrQuantity(newValue);
                    }
                });
            }
        } else {
            setCarouselCurrQuantity(newValue);
        }
    };
    React.useEffect(() => {
        if (isQuantityUpdated) {
            if (isProductBundles && isBundlesModal) {
                getCartState(context.actionContext)
                    .then(cartState => {
                        const cartlines = cartState.cart?.CartLines;
                        if (cartlines && cartlines.length) {
                            const cl = cartlines.find(cl => cl.ProductId === product.RecordId);
                            if (cl && cl.Quantity) {
                                setCurrBundleQuantity(cl.Quantity);
                                if (onQuantityChangeListener) {
                                    onQuantityChangeListener(product.RecordId, cl.Quantity);
                                }
                            }
                        }
                    })
                    .catch(e => {});
                context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: false });
                return;
            }
            if (isProductBundles && isNotificationModal) {
                getCartState(context.actionContext)
                    .then(cartState => {
                        const cartlines = cartState.cart?.CartLines;
                        if (cartlines && cartlines.length) {
                            const cl = cartlines.find(cl => cl.ProductId === product.RecordId);
                            if (cl && cl.Quantity) {
                                setCurrBundleQuantity(cl.Quantity);
                                if (onQuantityChangeListener) {
                                    onQuantityChangeListener(product.RecordId, cl.Quantity);
                                }
                            }
                        }
                    })
                    .catch(e => {});
                context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: false });
                return;
            }
            const cookies = context.actionContext.requestContext.cookies;
            const addedProductsToCollection =
                cookies.get(isNotificationModal ? 'notification_added_products' : 'added_products_bundles')?.value || [];
            if (Array.isArray(addedProductsToCollection)) {
                for (const obj of addedProductsToCollection) {
                    if (obj['productId'] === product.RecordId) {
                        setCurrBundleQuantity(obj['quantity']);
                        if (onQuantityChangeListener) {
                            onQuantityChangeListener(product.RecordId, obj['quantity']);
                        }
                    }
                }
            }
            context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: false });
        }
    }, [isQuantityUpdated]);

    React.useEffect(() => {
        if (removedProductFromCart && removedProductFromCart === product.RecordId) {
            setExistsInCartLines(false);
            context.actionContext.update(new GetUnbxdRemoveFromCartProductInput(), { product: null });
        }
    }, [removedProductFromCart]);

    React.useEffect(() => {
        if (isProductAddedToBundles) {
            resetQuantity();
        }
    }, [isProductAddedToBundles]);

    const resetQuantity = async () => {
        if (isProductBundles) {
            const cartState = await getCartState(context.actionContext);
            const cl = cartState.cart.CartLines?.find(c => c.ProductId === product.RecordId);
            if (cl && cl.Quantity) {
                if (isProductBundles && isBundlesModal) {
                    setCurrBundleQuantity(cl.Quantity);
                }
                if (isProductBundles && isNotificationModal) {
                    setCurrBundleQuantity(cl.Quantity);
                }
            }
        }
    };
    const resetQuantityOnLoad = async () => {
        if (isProductBundles) {
            const cartState = await getCartState(context.actionContext);
            const cl = cartState.cart.CartLines?.find(c => c.ProductId === product.RecordId);
            if (cl && cl.Quantity) {
                if (isProductBundles && isBundlesModal) {
                    setCurrBundleQuantity(cl.Quantity);
                } else if (!isBundlesModal) {
                    setCurrBundleQuantity(1);
                }
                if (isProductBundles && isNotificationModal) {
                    setCurrBundleQuantity(cl.Quantity);
                } else if (!isBundlesModal) {
                    setCurrBundleQuantity(1);
                }
            } else {
                setCurrBundleQuantity(1);
            }
        }
    };

    React.useEffect(() => {
        let isMounted = true;

        if (product && product.RecordId) {
            const baseImgUrl = context.request.apiSettings.baseImageUrl;
            const optimisticImages: IImageData[] = [];
            const validationUrls: string[] = [];

            // create product image urls starting from 002 to 003 because 001 is PrimaryImageUrl
            for (let i = 2; i <= 3; i++) {
                // Base image URL without size parameters
                const baseImagePath = `${baseImgUrl}Products/${product.ItemId}_000_00${i}.png`;

                // Optimistic URLs with full size for rendering (500px width, multiplier=1 since we want exact 500)
                const fullUrl = getOptimizedImageUrl(sanitizeImageUrl(baseImagePath), 250, 2);
                optimisticImages.push({ src: fullUrl, altText: product.Name || '' });

                // Validation URLs with 5px size for lightweight validation (5px width and height)
                const validationUrl = getOptimizedImageUrl(sanitizeImageUrl(baseImagePath), 5, 1, 5);
                validationUrls.push(validationUrl);
            }

            // Validate primary image
            const primaryImageUrl = product.PrimaryImageUrl;
            if (primaryImageUrl) {
                const primaryValidationUrl = getOptimizedImageUrl(
                    sanitizeImageUrl(generateImageUrl(primaryImageUrl, context.request.apiSettings) || ''),
                    5,
                    1,
                    5
                );
                validateSingleImageAsync(primaryValidationUrl)
                    .then(result => {
                        if (!isMounted) return;
                        setIsPrimaryImageValid(result !== null);
                    })
                    .catch(() => {
                        if (!isMounted) return;
                        setIsPrimaryImageValid(false);
                    });
            } else {
                setIsPrimaryImageValid(false);
            }

            // Validate images in background - only update state once with final validated results
            // to prevent double renders and image flickering
            validateMediaLocaionAsync(validationUrls)
                .then(validatedResults => {
                    if (!isMounted) return;
                    // Filter optimistic images based on validation results
                    // validatedResults will contain only URLs that returned 200/201
                    const validIndices = validationUrls
                        .map((url, index) => (validatedResults.some(result => result.src === url) ? index : -1))
                        .filter(index => index !== -1);

                    const filteredImages = validIndices.map(index => optimisticImages[index]);

                    if (filteredImages.length > 0) {
                        setImages({ validatedImages: filteredImages, hasValidImages: true, isValidating: false });
                    } else {
                        setImages({ validatedImages: [], hasValidImages: false, isValidating: false });
                    }
                })
                .catch(error => {
                    if (!isMounted) return;
                    context.actionContext.telemetry.exception(error);
                    context.actionContext.telemetry.debug('Unable to validate product images');
                    // On error, show optimistic images
                    setImages({ validatedImages: optimisticImages, hasValidImages: true, isValidating: false });
                });
        }

        return () => {
            isMounted = false;
        };
    }, [product?.RecordId, product?.ItemId]); // Use stable identifiers instead of product object reference

    // Update inventory availability when product prop changes (separate from image loading)
    React.useEffect(() => {
        if (product) {
            if (product.ProductHomeDeliveryInventory && product.ProductHomeDeliveryInventory.IsProductAvailable) {
                setIsProductAvailable(true);
                setIsEcomProductAvailable(true);
            }
            if (
                product.ProductClickAndCollectInventory &&
                product.ProductClickAndCollectInventory.PhysicalAvailableInventoryLevelCode !== 'OOS'
            ) {
                setIsProductAvailable(true);
                setIsCnCProductAvailable(true);
            }
        }
    }, [product?.ProductHomeDeliveryInventory, product?.ProductClickAndCollectInventory]);

    React.useEffect(() => {
        if (product.DeliveryOptions && product.DeliveryOptions.length > 0) {
            const hasHomeDelivery = product.DeliveryOptions.some(option => option.Code !== 'ClickCol' && option.Code !== 'Common MOD');
            const hasClickAndCollect = product.DeliveryOptions.some(option => option.Code === 'ClickCol');
            setHasHomeDelMode(hasHomeDelivery);
            setHasCNCMode(hasClickAndCollect);
        }
    }, [product.DeliveryOptions]);

    React.useEffect(() => {
        if (isFetchingInventory) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    }, [isFetchingInventory]);

    React.useEffect(() => {
        // fetchInventory();
        getCartState(context.actionContext).then(cartState => {
            const existsInCart = cartState.cart.CartLines?.find(line => line.ProductId === product.RecordId);
            if (existsInCart) {
                setExistsInCartLines(true);
            }
        });
    }, []);

    //VSI CUSTOMIZATION -END - Task 11167: PLP hover image flip

    let productUrl = getProductPageUrlSync(product.Name || '', product.RecordId, context && context.actionContext, undefined);
    if (allowBack) {
        productUrl = updateProductUrl(productUrl, context);
    }

    const getCartData = async () => {
        if (isNewCarouselDesign) {
            const setCurrQuantity = async () => {
                const cartState = await getCartState(context.actionContext);
                const cl = cartState.cart.CartLines?.find(c => c.ProductId === product.RecordId);
                if (cl && cl.Quantity) {
                    setCarouselCurrQuantity(cl.Quantity);
                    setExistsInCartLines(true);
                } else {
                    setCarouselCurrQuantity(0);
                    setExistsInCartLines(false);
                }
            };
            setCurrQuantity();
            return;
        }
        const cart = await getCartFromCustomer(context.actionContext);
        setCartData(cart);
        await resetQuantityOnLoad();
    };

    const addProductToCartNewCarousel = async (): Promise<void> => {
        if (isEcomProductAvailable) {
            setIsAddingToBasket(true);
            try {
                const cartState = await getCartState(context.actionContext);
                const productList = new Array();
                productList.push({
                    product: product,
                    count: carouselCurrQuantity,
                    enableStockCheck: context.app.config.enableStockCheck
                });
                const result = await cartState?.addProductsToCart(productList);
                if (result.status !== 'FAILED') {
                    setExistsInCartLines(true);
                    context.actionContext.update(new GetUnbxdAddToCartProductInput(), { product });
                    await cartState.refreshCart({});
                }
            } catch (error) {
                console.error('Error adding product to cart:', error);
            } finally {
                setIsAddingToBasket(false);
            }
        } else if (isCnCProductAvailable) {
            if (onClickAndCollect) {
                onClickAndCollect(product, setExistsInCartLines);
            }
        }
    };

    const deSelectProduct = async () => {
        const cartState = await getCartState(context.actionContext);
        const cartlineToRemove = cartState.cart.CartLines?.find(cl => cl.ProductId === product.RecordId);
        if (isProductBundles && isBundlesModal) {
            if (cartlineToRemove) {
                const input = {
                    cartLineIds: [cartlineToRemove.LineId!.toString()]
                };
                cartState
                    .removeCartLines(input)
                    .then(() => {
                        context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
                    })
                    .catch(error => {});
            }
            return;
        }
        if (isProductBundles && isNotificationModal) {
            if (cartlineToRemove) {
                const input = {
                    cartLineIds: [cartlineToRemove.LineId!.toString()]
                };
                cartState
                    .removeCartLines(input)
                    .then(() => {
                        context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
                    })
                    .catch(error => {});
            }
            return;
        }

        const cookies = context.actionContext.requestContext.cookies;
        let productsAddedInBundles =
            cookies.get(isNotificationModal ? 'notification_added_products' : 'added_products_bundles')?.value || [];
        if (Array.isArray(productsAddedInBundles)) {
            for (let i = 0; i < productsAddedInBundles.length; i++) {
                if (productsAddedInBundles[i]['productId'] === product.RecordId) {
                    delete productsAddedInBundles[i];
                }
            }
            const updatedProductsAddedInBundles: IDobbiesAddedProductToBundle[] = [];
            productsAddedInBundles.map(prod => {
                if (prod && prod['productId']) {
                    const dobbiesProductData: IDobbiesAddedProductToBundle = {};
                    dobbiesProductData.productId = prod['productId'];
                    dobbiesProductData.quantity = prod['quantity'];
                    dobbiesProductData.price = prod['price'];
                    dobbiesProductData.maxQuantity = prod['maxQuantity'];
                    updatedProductsAddedInBundles.push(dobbiesProductData);
                }
            });
            const cookieName = isNotificationModal ? 'notification_added_products' : 'added_products_bundles';
            cookies.set(cookieName, updatedProductsAddedInBundles);
            context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
        }
    };

    const _getAllStores = async (
        latitude?: number,
        longitude?: number,
        radius?: number,
        distanceUnitValue?: number
    ): Promise<IFullOrgUnitAvailability[]> => {
        const orgUnitLocationsInput = new GetAllOrgUnitLocationsByAreaInput(latitude, longitude, radius, distanceUnitValue, false);
        const orgUnitLocations = await getAllOrgUnitLocationsByArea(orgUnitLocationsInput, context.actionContext);
        return orgUnitLocations;
    };

    const onQuantityChange = async (newValue: number) => {
        const cartState = await getCartState(context.actionContext);
        const cl = cartState.cart.CartLines?.find(c => c.ProductId === product.RecordId);
        if (isProductBundles && isBundlesModal) {
            if (!cl) {
                if (onQuantityChangeListener) {
                    onQuantityChangeListener(product.RecordId, newValue);
                }
                setCurrBundleQuantity(newValue);
                return;
            }
            if (cl && cl.Quantity && maxQuantityForBundle && simpleProduct) {
                if (newValue > maxQuantityForBundle) {
                    return;
                }
                const diffInQuantity = newValue - cl.Quantity;
                const deliveryOptions = await getDeliveryOptionsAsync({ callerContext: context.actionContext, queryResultSettings: {} }, [
                    product.RecordId
                ]);
                const emailDeliveryModeCode = context.actionContext.requestContext.channel?.EmailDeliveryModeCode;
                if (diffInQuantity > 0) {
                    const addProductToCartInput = {
                        product: simpleProduct,
                        quantity: diffInQuantity,
                        enableStockCheck: context.app.config.enableStockCheck,
                        availableQuantity: maxQuantityForBundle,
                        isAddEmailDeliveryItemToCart:
                            ArrayExtensions.hasElements(deliveryOptions) &&
                            ArrayExtensions.hasElements(deliveryOptions[0].DeliveryOptions) &&
                            deliveryOptions[0].DeliveryOptions[0].Code === emailDeliveryModeCode
                    };
                    const cookies = context.actionContext.requestContext.cookies;
                    const cncProducts = cookies.get('cnc_products').value || [];
                    if (Array.isArray(cncProducts) && cncProducts.includes(simpleProduct.ItemId)) {
                        const deliveryOptions = await getDeliveryOptionsAsync(
                            { callerContext: context.actionContext, queryResultSettings: {} },
                            [simpleProduct.RecordId]
                        );
                        let cncOption: DeliveryOption | undefined;
                        deliveryOptions.map(dopt => {
                            dopt.DeliveryOptions?.map(delOpt => {
                                if (delOpt.Code === 'ClickCol') {
                                    cncOption = delOpt;
                                }
                            });
                        });
                        const sLocations = await _getAllStores(31.5070767, 74.4315609, 0, 0);
                        const storeLocation = sLocations.find(sl => {
                            return sl.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId === cl.FulfillmentStoreId;
                        });
                        if (storeLocation && storeLocation.OrgUnitAvailability?.OrgUnitLocation) {
                            cartState
                                .addProductToCart({
                                    product: simpleProduct,
                                    count: diffInQuantity,
                                    location: storeLocation.OrgUnitAvailability?.OrgUnitLocation,
                                    deliveryMode: cncOption?.Code
                                })
                                .then(async result => {
                                    if (result.status === 'SUCCESS') {
                                        context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                                    }
                                })
                                .catch(e => {});
                        }
                    } else {
                        cartState
                            .addProductToCart(addProductToCartInput)
                            .then(async result => {
                                if (result.status === 'SUCCESS') {
                                    context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                                }
                            })
                            .catch(e => {});
                    }
                } else if (diffInQuantity < 0) {
                    cartLineQuantityUpdatedAsync(true, cartState, context.actionContext.telemetry, [simpleProduct], cl, newValue)
                        .then((cartActionResult: ICartActionResult | undefined): boolean => {
                            if (cartActionResult?.status === 'SUCCESS') {
                                context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
                                return true;
                            }
                            return false;
                        })
                        .catch(e => {});
                }
                if (onQuantityChangeListener) {
                    onQuantityChangeListener(product.RecordId, newValue);
                }
                setCurrBundleQuantity(newValue);
            }
            return;
        }
        if (isProductBundles && isNotificationModal) {
            if (!cl) {
                if (onQuantityChangeListener) {
                    onQuantityChangeListener(product.RecordId, newValue);
                }
                setCurrBundleQuantity(newValue);
                return;
            }
            if (cl && cl.Quantity && maxQuantityForBundle && simpleProduct) {
                if (newValue > maxQuantityForBundle) {
                    return;
                }
                const diffInQuantity = newValue - cl.Quantity;
                const deliveryOptions = await getDeliveryOptionsAsync({ callerContext: context.actionContext, queryResultSettings: {} }, [
                    product.RecordId
                ]);
                const emailDeliveryModeCode = context.actionContext.requestContext.channel?.EmailDeliveryModeCode;
                if (diffInQuantity > 0) {
                    const addProductToCartInput = {
                        product: simpleProduct,
                        quantity: diffInQuantity,
                        enableStockCheck: context.app.config.enableStockCheck,
                        availableQuantity: maxQuantityForBundle,
                        isAddEmailDeliveryItemToCart:
                            ArrayExtensions.hasElements(deliveryOptions) &&
                            ArrayExtensions.hasElements(deliveryOptions[0].DeliveryOptions) &&
                            deliveryOptions[0].DeliveryOptions[0].Code === emailDeliveryModeCode
                    };

                    const cookies = context.actionContext.requestContext.cookies;
                    const cncProducts = cookies.get('cnc_products').value || [];
                    if (Array.isArray(cncProducts) && cncProducts.includes(simpleProduct.ItemId)) {
                        const deliveryOptions = await getDeliveryOptionsAsync(
                            { callerContext: context.actionContext, queryResultSettings: {} },
                            [simpleProduct.RecordId]
                        );
                        let cncOption: DeliveryOption | undefined;
                        deliveryOptions.map(dopt => {
                            dopt.DeliveryOptions?.map(delOpt => {
                                if (delOpt.Code === 'ClickCol') {
                                    cncOption = delOpt;
                                }
                            });
                        });
                        const sLocations = await _getAllStores(31.5070767, 74.4315609, 0, 0);
                        const storeLocation = sLocations.find(sl => {
                            return sl.OrgUnitAvailability?.OrgUnitLocation?.InventoryLocationId === cl.FulfillmentStoreId;
                        });
                        if (storeLocation && storeLocation.OrgUnitAvailability?.OrgUnitLocation) {
                            cartState
                                .addProductToCart({
                                    product: simpleProduct,
                                    count: diffInQuantity,
                                    location: storeLocation.OrgUnitAvailability?.OrgUnitLocation,
                                    deliveryMode: cncOption?.Code
                                })
                                .then(async result => {
                                    if (result.status === 'SUCCESS') {
                                        context.actionContext.update(new CartModulesStateShareInput(), { isQuantityUpdated: true });
                                    }
                                })
                                .catch(e => {});
                        }
                    } else {
                        cartState
                            .addProductToCart(addProductToCartInput)
                            .then(async result => {
                                if (result.status === 'SUCCESS') {
                                    context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
                                }
                            })
                            .catch(e => {});
                    }
                } else if (diffInQuantity < 0) {
                    cartLineQuantityUpdatedAsync(true, cartState, context.actionContext.telemetry, [simpleProduct], cl, newValue)
                        .then((cartActionResult: ICartActionResult | undefined): boolean => {
                            if (cartActionResult?.status === 'SUCCESS') {
                                context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
                                return true;
                            }
                            return false;
                        })
                        .catch(e => {});
                }
                if (onQuantityChangeListener) {
                    onQuantityChangeListener(product.RecordId, newValue);
                }
                setCurrBundleQuantity(newValue);
            }
            return;
        }
        const cookies = context.actionContext.requestContext.cookies;
        const addedProductsToCollection =
            cookies.get(isNotificationModal ? 'notification_added_products' : 'added_products_bundles')?.value || [];
        const updatedProducts: IDobbiesAddedProductToBundle[] = [];
        if (Array.isArray(addedProductsToCollection)) {
            for (const obj of addedProductsToCollection) {
                if (obj['productId'] === product.RecordId) {
                    const valueToBeUpdated = newValue;
                    if (valueToBeUpdated > 0) {
                        updatedProducts.push({
                            productId: obj['productId'],
                            price: obj['price'],
                            quantity: valueToBeUpdated,
                            maxQuantity: maxQuantityForBundle,
                            inventoryLocationId: obj['inventoryLocationId']
                        });
                    }
                } else {
                    updatedProducts.push({
                        productId: obj['productId'],
                        price: obj['price'],
                        quantity: obj['quantity'],
                        maxQuantity: obj['maxQuantity'],
                        inventoryLocationId: obj['inventoryLocationId']
                    });
                }
            }
            const cookieName = isNotificationModal ? 'notification_added_products' : 'added_products_bundles';
            cookies.set(cookieName, updatedProducts);
        }
        setCurrBundleQuantity(newValue);
        context.actionContext.update(new CartModulesStateShareInput(), { isCartUpdated: true });
        if (onQuantityChangeListener) {
            onQuantityChangeListener(product.RecordId, newValue);
        }
    };

    const checkboxClicked = () => {
        if (isProductAddedToBundles) {
            deSelectProduct();
        } else if (onBundleProductCheckBoxSelected) {
            onBundleProductCheckBoxSelected(product.RecordId);
        }
    };

    React.useEffect(() => {
        getCartData();
        setUpdatedProductPrice(product.Price);

        productImageRef.current?.addEventListener('contextmenu', e => {
            e.preventDefault();
        });
    }, []);

    /**
     * Gets the react node for  product description.
     * @param  quickview - Quick view node.
     * @param  item - Product id to de displayed in quickview.
     * @returns The product quickview component.     */
    function renderQuickView(quickview: React.ReactNode, item?: number): JSX.Element | undefined {
        if (quickview === null) {
            return undefined;
        }
        return React.cloneElement(quickview as React.ReactElement, { selectedProductId: item });
    }

    // Construct telemetry attribute to render
    const payLoad = getPayloadObject('click', telemetryContent!, '', product.RecordId.toString());

    const attribute = getTelemetryAttributes(telemetryContent!, payLoad);
    //VSI CUSTOMIZATION -START - Check current loyalty tier id.
    const getTierId = () => {
        if (loyalty!?.LoyaltyGroups!?.length > 0) {
            const highestActiveLoyaltyCardTier = loyalty!.LoyaltyGroups![0]?.HighestActiveLoyaltyCardTier;
            const loyaltyCardTiers = loyalty!.LoyaltyGroups![0]?.LoyaltyCardTiers;
            const loyaltyCardTier = loyaltyCardTiers?.find(tier => tier.RecordId === highestActiveLoyaltyCardTier);
            return loyaltyCardTier?.LoyaltyTierRecordId;
        }
        return undefined;
    };
    //VSI CUSTOMIZATION -END
    const checkClubPlusDiscounts =
        discountLine && discountLine.length > 0 && discountLine?.find(x => x.OfferId === context.app.config.discountId);
    const checkUserLoyalty = getTierId() === context.app.config.LoyaltyTierId ? true : undefined;
    // cartData && cartData.AffiliationLines && cartData.AffiliationLines.find(x => x.LoyaltyTierId === context.app.config.LoyaltyTierId);
    // const checkNonClubPlusDiscounts = discountLine && discountLine.find(x => x.OfferId !== context.app.config.discountId);
    const membershipDiscount = discountLine && discountLine.find(x => x.OfferId === context.app.config.membershipDiscountId);
    //VSI CUSTOMIZATION -START - Task 11167: PLP hover image flip
    const outOfSeason =
        product.AttributeValues?.find(attr => attr.Name?.toLocaleLowerCase() === 'outofseason')?.TextValue?.toLowerCase() === 'yes';
    const getImgContainer = () => {
        // Show empty image placeholder when no valid images are available
        if (!isPrimaryImageValid && !images.hasValidImages) {
            return (
                <div className='msc-product__image' key={product.RecordId}>
                    <div className='msc-empty-image' />
                </div>
            );
        }
        if (!(typeName === 'dobbies-search-result-container' || images.hasValidImages === false)) {
            return (
                <div className='msc-product__image' key={product.RecordId}>
                    {isPrimaryImageValid &&
                        renderProductPlacementImage(
                            imageSettings,
                            context.request.gridSettings,
                            product.PrimaryImageUrl,
                            product.Name,
                            context.request.apiSettings,
                            undefined
                        )}
                    {!isPrimaryImageValid &&
                        images.hasValidImages &&
                        renderProductPlacementImage(
                            imageSettings,
                            context.request.gridSettings,
                            images.validatedImages[0].src,
                            images.validatedImages[0].altText || product.Name,
                            context.request.apiSettings,
                            product
                        )}
                </div>
            );
        }
        return (
            <div className='msc-product__image' key={product.RecordId}>
                {isPrimaryImageValid &&
                    renderProductPlacementImage(
                        imageSettings,
                        context.request.gridSettings,
                        product.PrimaryImageUrl,
                        product.Name,
                        context.request.apiSettings,
                        product
                    )}

                {images.validatedImages &&
                    images.validatedImages.length > 0 &&
                    renderProductPlacementImage(
                        imageSettings,
                        context.request.gridSettings,
                        images.validatedImages[0].src,
                        images.validatedImages[0].altText || product.Name,
                        context.request.apiSettings,
                        product
                    )}
            </div>
        );
    };

    //VSI CUSTOMIZATION -END - Task 11167: PLP hover image flip
    const isISO =
        product.AttributeValues?.find(attr => attr.Name?.toLocaleLowerCase() === 'onlyinstore')?.TextValue?.toLowerCase() === 'yes';
    const isComingSoon =
        product.AttributeValues?.find(attr => attr.Name?.toLocaleLowerCase() === 'comingsoon')?.TextValue?.toLowerCase() === 'yes';

    const homeDeliveryAvailable = isEcomProductAvailable && hasHomeDelMode;
    const clickAndCollectAvailable = isCnCProductAvailable && hasCNCMode;

    // Memoize carousel images to prevent unnecessary re-renders of CustomCarousel
    // const productImageUrl = useMemo(() => generateImageUrl(product.PrimaryImageUrl, context.request.apiSettings) || '', [
    //     product.PrimaryImageUrl
    // ]);

    // Helper function to sanitize and optimize image URLs
    const processImageUrl = (url: string | undefined): string => {
        if (!url) {
            return '';
        }
        let processedUrl = generateImageUrl(url, context.request.apiSettings) || '';
        // Handle encoded forward slashes
        if (processedUrl.includes('%2F')) {
            processedUrl = processedUrl.replace(/%2F/g, '/');
        }
        if (processedUrl) {
            const sanitizedUrl = sanitizeImageUrl(processedUrl);
            processedUrl = getOptimizedImageUrl(sanitizedUrl, 250);
        }
        return processedUrl;
    };

    const productImageUrl = useMemo(() => processImageUrl(product.PrimaryImageUrl), [product.PrimaryImageUrl]);

    const carouselImages: IMediaData[] = useMemo(() => {
        const validImages: IMediaData[] = [];

        // Only include primary image if it's valid
        if (isPrimaryImageValid && productImageUrl) {
            validImages.push({ src: productImageUrl, altText: product.Name || '' });
        }

        // Add validated secondary images
        images.validatedImages.forEach(img => {
            validImages.push({
                src: processImageUrl(img.src),
                altText: img.altText || product.Name || ''
            });
        });

        return validImages;
    }, [productImageUrl, product.Name, images.validatedImages, isPrimaryImageValid]);

    // Check if any valid images exist for the carousel
    const hasAnyValidImage = carouselImages.length > 0;

    // Memoize carousel click handler
    const handleCarouselClick = useCallback(() => {
        const url = productUrl.includes(`${product.RecordId}`) ? productUrl : '#';
        if (url !== '#') {
            window.location.href = url;
        }
    }, [productUrl, product.RecordId]);

    // VSI CUSTOMIZATION - New design render for category page
    const renderCategoryPageDesign = () => {
        // Get key selling points/bullet points from product attributes
        const plpFeatures = product.AttributeValues?.find(attr => attr.Name === 'PLP features')?.TextValue;

        // Always use carousel for consistent layout - prevents flickering when additional images load async
        // Show empty image placeholder when no valid images are available
        const renderProductImage = () => {
            if (!hasAnyValidImage) {
                return <div className='msc-empty-image' />;
            }
            return <CustomCarousel mediaGalleryItems={carouselImages} onSlideClick={handleCarouselClick} />;
        };

        return (
            <div onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                <div
                    onClick={onTelemetryClick(telemetryContent!, payLoad, product.Name!)}
                    aria-label={renderLabel(
                        product.Name,
                        context.cultureFormatter.formatCurrency(product.Price, context.request.channel?.Currency),
                        product.AverageRating,
                        ratingAriaLabel
                    )}
                    key={product.RecordId}
                    data-product-id={product.ItemId}
                    data-item-id={product.ItemId}
                    {...attribute}
                    className={`msc-product  ${!isCnCProductAvailable && !isEcomProductAvailable && !isLoading ? 'oos' : ''}`}
                >
                    {/* Image Section */}
                    <div className='msc-product__image-wrapper'>
                        {renderProductImage()}
                        {/* Discount badge on image */}
                        <VsiCustomBadges productData={product} context={context} mode='image' />
                        {(isHover || isMobile) && context.request.user.isAuthenticated && (
                            <div className='msc-wishlist-button fade-in-plp'>
                                <AddToWishlistComponent
                                    className='msc-add-to-cart-extra-actions'
                                    addToWishlistButtonText='Add to Wishlist'
                                    removeFromWishlistButtonText='Remove from Wishlist'
                                    addToWishlistMessage='Added'
                                    removedFromWishlistMessage='Removed'
                                    addItemToWishlistError='Error'
                                    removeItemFromWishlistError='Remove Error'
                                    nameOfWishlist='My Favourites'
                                    // @ts-ignore
                                    data={{ product, wishlists }}
                                    context={context}
                                    id={id}
                                    ariaRole='button'
                                    typeName={typeName}
                                    // onError={onAddToWishlistFailed(callbacks, resources, product)}
                                />
                            </div>
                        )}
                        {isHover && quickViewButton && renderQuickView(quickViewButton, product.RecordId)}
                    </div>

                    {/* Content Section */}
                    <div className='msc-product__details-wrapper'>
                        {/* Text Badges - Sale, Click & Collect only, etc. */}
                        <div className='msc-product__details-wrapper-top'>
                            {!isLoading && (
                                <div className='product-card-badge'>
                                    <VsiCustomBadges
                                        productData={product}
                                        context={context}
                                        isProductAvailableCNC={clickAndCollectAvailable}
                                        isProductAvailableEcom={homeDeliveryAvailable}
                                        isISO={isISO}
                                        isComingSoon={isComingSoon}
                                        isFetchingInventory={isLoading}
                                        mode='text'
                                    />
                                </div>
                            )}

                            {/* Product Name */}
                            <a
                                className='msc-product__url'
                                href={productUrl.includes(`${product.RecordId}`) ? productUrl : '#'}
                                style={{ width: '100%' }}
                                key={product.RecordId}
                                aria-label={`${product.RecordId}`}
                            >
                                <h2 title={getProductName(product, product.Name!)} className='msc-product__title'>
                                    {getProductName(product, product.Name!)}
                                </h2>
                            </a>

                            {/* Price Section */}
                            <div className='msc-product__price-section'>
                                {renderPrice(
                                    context,
                                    typeName,
                                    id,
                                    checkUserLoyalty && membershipDiscount ? product.BasePrice : nonClubPlusDiscount?.AdjustedPrice!,
                                    checkUserLoyalty && membershipDiscount ? product.Price : nonClubPlusDiscount?.CustomerContextualPrice!,
                                    savingsText,
                                    freePriceText,
                                    originalPriceText,
                                    currentPriceText,
                                    checkUserLoyalty && membershipDiscount ? discountLine : nonClubPlusDiscount?.DiscountLines,
                                    cartData,
                                    updatedProductPrice,
                                    getTierId,
                                    checkClubPlusDiscounts
                                )}
                            </div>

                            {/* Club Plus Discount Section */}
                            {checkClubPlusDiscounts && checkUserLoyalty && (
                                <div className='product-card-club-plus-discount product-card-club-plus product-card-club-plus'>
                                    <p>Club Plus price</p>
                                    <p className='product-card-club-plus-price'>{context.cultureFormatter.formatCurrency(product.Price)}</p>
                                </div>
                            )}
                            {checkClubPlusDiscounts && checkUserLoyalty === undefined && (
                                <div
                                    className={
                                        product.clubPlusBanner
                                            ? 'product-card-club-plus-badge badge-collapse-pdp'
                                            : 'product-card-club-plus-badge'
                                    }
                                >
                                    {product.clubPlusBanner && (
                                        <div className='product-club-plus-container-info'>
                                            <div
                                                onClick={() => hideBanner && hideBanner(product.RecordId)}
                                                className='product-card-club-plus-cross'
                                            ></div>
                                            <p className='product-club-plus-info'>
                                                {/* Join Dobbies Club Plus for just £12 a year and enjoy 10% off on plants, bulbs and Seeds.{' '} */}
                                                Join Club Plus and save 10% on plants, bulbs and seeds all year round
                                                <span>
                                                    {' '}
                                                    <a href={badgeLink ? badgeLink : ''}>Find out more</a>
                                                </span>
                                            </p>
                                        </div>
                                    )}
                                    <div className='product-card-club-plus'>
                                        <p>Club Plus price</p>
                                        <p className='product-card-club-plus-price'>
                                            {context.cultureFormatter.formatCurrency(product.Price)}
                                        </p>
                                        <div
                                            onClick={() => showBanner && showBanner(product.RecordId)}
                                            className='product-card-club-plus-icon'
                                        >
                                            <p>?</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Bullet Points / PLP Features Points */}
                            {plpFeatures && plpFeatures !== '' && (
                                <RichTextComponent text={plpFeatures} className='plp-features msc-product__bullet-points' />
                            )}
                        </div>
                        <div className='msc-product__details-wrapper-bottom'>
                            {/* Delivery Availability Section */}
                            {!isLoading && (
                                <div className='msc-product__delivery-availability msc-product__delivery'>
                                    <div className='msc-product__delivery-option'>
                                        {homeDeliveryAvailable ? (
                                            <div className='msc-product__isHD-active' />
                                        ) : (
                                            <div className='msc-product__isHD' />
                                        )}
                                        <span className='msc-product__delivery-label'>Home Delivery:</span>
                                        <span
                                            className={`msc-product__delivery-status ${
                                                homeDeliveryAvailable ? 'available' : 'not available'
                                            }`}
                                        >
                                            {homeDeliveryAvailable ? 'available' : 'not available'}
                                        </span>
                                    </div>
                                    <div className='msc-product__delivery-option'>
                                        {!homeDeliveryAvailable && outOfSeason ? (
                                            <div className='msc-product__isCnC' />
                                        ) : clickAndCollectAvailable ? (
                                            <div className='msc-product__isCnC-active' />
                                        ) : (
                                            <div className='msc-product__isCnC' />
                                        )}
                                        <span className='msc-product__delivery-label'>Click & Collect:{''}</span>
                                        <span
                                            className={`msc-product__delivery-status ${
                                                clickAndCollectAvailable ? 'available' : 'not available'
                                            }`}
                                        >
                                            {clickAndCollectAvailable ? 'available' : 'not available'}
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Add to Wishlist Link */}
                            {context.request.user.isAuthenticated && (
                                <div className='msc-product__wishlist-link'>
                                    <AddToWishlistComponent
                                        className='msc-add-to-cart-extra-actions'
                                        addToWishlistButtonText='Add to wishlist'
                                        removeFromWishlistButtonText='Added to wishlist'
                                        addToWishlistMessage='Added'
                                        removedFromWishlistMessage='Removed'
                                        addItemToWishlistError='Error'
                                        removeItemFromWishlistError='Remove Error'
                                        nameOfWishlist='My Favourites'
                                        showButtonText={true}
                                        // @ts-ignore
                                        data={{ product, wishlists }}
                                        context={context}
                                        id={id}
                                        ariaRole='button'
                                        typeName={typeName}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    // VSI CUSTOMIZATION - End new design render for category page

    // VSI CUSTOMIZATION - Conditionally render new design for category pages
    if (product.ItemId && isCategoryPage() && !isUnbxdWidget) {
        return renderCategoryPageDesign();
    }

    return product.ItemId ? (
        <div onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
            <div
                onClick={onTelemetryClick(telemetryContent!, payLoad, product.Name!)}
                aria-label={renderLabel(
                    product.Name,
                    context.cultureFormatter.formatCurrency(product.Price, context.request.channel?.Currency),
                    product.AverageRating,
                    ratingAriaLabel
                )}
                key={product.RecordId}
                data-product-id={product.ItemId}
                data-item-id={product.ItemId}
                className={`msc-product ${existsInCartLines && showUnbxdAddToBasket ? 'already-added' : ''}`}
                {...attribute}
            >
                <div
                    className={isProductAddedToBundles ? 'productAdded' : ''}
                    style={{
                        position: 'relative'
                    }}
                >
                    {isUnbxdWidget && showRemoveProductButton && (
                        <button className='unbxd-product-remove' onClick={onRemoveProduct}></button>
                    )}
                    <div className='msc-product__image'>
                        {isProductBundles && (
                            <div>
                                <input
                                    className='msc-product__checkbox'
                                    type='checkbox'
                                    checked={isProductAddedToBundles}
                                    onClick={() => {
                                        checkboxClicked();
                                    }}
                                />
                                <svg xmlns='http://www.w3.org/2000/svg' width='13' height='16' viewBox='761.5 1255 13 16'>
                                    <g data-name='Group 1749'>
                                        <path
                                            d='m761.5 1265 5 6'
                                            stroke-linejoin='round'
                                            stroke-linecap='round'
                                            stroke-width='1.5'
                                            stroke='#fff'
                                            fill='transparent'
                                            data-name='Line 1331'
                                        />
                                        <path
                                            d='m774.5 1255-8 16'
                                            stroke-linejoin='round'
                                            stroke-linecap='round'
                                            stroke-width='1.5'
                                            stroke='#fff'
                                            fill='transparent'
                                            data-name='Line 1332'
                                        />
                                    </g>
                                </svg>
                            </div>
                        )}
                        <a
                            href={productUrl.includes(`${product.RecordId}`) ? productUrl : '#'}
                            key={product.RecordId}
                            style={{
                                display: 'block',
                                outline: 'none'
                            }}
                            aria-label={`${product.RecordId}`}
                        >
                            {/* //VSI CUSTOMIZATION -START - Task 11167: PLP hover image flip */}
                            {getImgContainer()}
                            <VsiCustomBadges productData={product} context={context} mode='image' />
                            {/* //VSI CUSTOMIZATION -END - Task 11167: PLP hover image flip */}
                        </a>
                    </div>

                    {isHover && quickViewButton && renderQuickView(quickViewButton, product.RecordId)}

                    {(isHover || isMobile) && context.request.user.isAuthenticated && (
                        <div className='msc-wishlist-button fade-in-plp'>
                            <AddToWishlistComponent
                                className='msc-add-to-cart-extra-actions'
                                addToWishlistButtonText='Add to Wishlist'
                                removeFromWishlistButtonText='Remove from Wishlist'
                                addToWishlistMessage='Added'
                                removedFromWishlistMessage='Removed'
                                addItemToWishlistError='Error'
                                removeItemFromWishlistError='Remove Error'
                                nameOfWishlist='My Favourites'
                                // @ts-ignore
                                data={{ product, wishlists }}
                                context={context}
                                id={id}
                                ariaRole='button'
                                typeName={typeName}
                                // onError={onAddToWishlistFailed(callbacks, resources, product)}
                            />
                        </div>
                    )}
                </div>
                <div>
                    {!isUnbxdWidget && !isLoading && (
                        <div className='product-card-badge'>
                            <VsiCustomBadges
                                productData={product}
                                context={context}
                                isProductAvailableCNC={clickAndCollectAvailable}
                                isProductAvailableEcom={homeDeliveryAvailable}
                                isISO={isISO}
                                isComingSoon={isComingSoon}
                                isFetchingInventory={isLoading}
                                mode='text'
                                pageType='plp'
                            />
                        </div>
                    )}
                    <div className='msc-product__content'>
                        {isUnbxdWidget && (
                            <div className='product-card-badge'>
                                <VsiCustomBadges
                                    productData={product}
                                    context={context}
                                    isProductAvailableCNC={clickAndCollectAvailable}
                                    isProductAvailableEcom={homeDeliveryAvailable}
                                    isISO={isISO}
                                    isComingSoon={isComingSoon}
                                    mode='text'
                                    isFetchingInventory={isFetchingInventory}
                                    isUnbxdWidget={isUnbxdWidget}
                                />
                            </div>
                        )}
                        <a
                            className='msc-product__url'
                            href={productUrl.includes(`${product.RecordId}`) ? productUrl : '#'}
                            style={{
                                width: '100%'
                            }}
                            key={product.RecordId}
                            aria-label={`${product.RecordId}`}
                        >
                            <div className={`msc-product__details ${isUnbxdWidget ? 'no-price' : ''}`}>
                                {/* <h4 className='msc-product__title'>{product.Name}</h4> */}
                                <a href={productUrl}>
                                    <h4 title={getProductName(product, product.Name!)} className='msc-product__title'>
                                        {getProductName(product, product.Name!)}
                                    </h4>
                                </a>
                                {!isUnbxdWidget &&
                                    renderPrice(
                                        context,
                                        typeName,
                                        id,
                                        checkUserLoyalty && membershipDiscount ? product.BasePrice : nonClubPlusDiscount?.AdjustedPrice!,
                                        checkUserLoyalty && membershipDiscount
                                            ? product.Price
                                            : nonClubPlusDiscount?.CustomerContextualPrice!,
                                        savingsText,
                                        freePriceText,
                                        originalPriceText,
                                        currentPriceText,
                                        checkUserLoyalty && membershipDiscount ? discountLine : nonClubPlusDiscount?.DiscountLines,
                                        cartData,
                                        updatedProductPrice,
                                        getTierId,
                                        checkClubPlusDiscounts
                                    )}

                                {/* {renderDescription(product.Description)} */}
                                {!context.app.config.hideRating &&
                                    renderRating(context, typeName, id, product.AverageRating, product.TotalRatings, ratingAriaLabel)}

                                {/*do not show delivery and C&C icons on plp*/}
                                {showDeliveryIcons && (
                                    <div className='msc-product__delivery row'>
                                        {product!.isHomeDelivery ? (
                                            <div className='msc-product__isHD-active' />
                                        ) : (
                                            <div className='msc-product__isHD' />
                                        )}
                                        {!product!.isHomeDelivery && outOfSeason ? (
                                            <div className='msc-product__isCnC' />
                                        ) : product!.isCnC ? (
                                            <div className='msc-product__isCnC-active' />
                                        ) : (
                                            <div className='msc-product__isCnC' />
                                        )}
                                    </div>
                                )}
                            </div>
                        </a>

                        {isProductBundles && (
                            <div className='msc-product__product-quantity msc-cart-line__product-quantity'>
                                <label className='quantity-label'>Quantity:</label>
                                <Quantity
                                    id={`msc-cart-line__quantity_${product.RecordId}`}
                                    currentCount={currBundleQuantity}
                                    onChange={onQuantityChange}
                                    hideQuantityControls={false}
                                    disabledInput={false}
                                    max={maxQuantityForBundle}
                                    min={1}
                                />
                            </div>
                        )}

                        {isNewCarouselDesign && (
                            <div className='msc-product__product-quantity msc-cart-line__product-quantity'>
                                <label className='quantity-label'>Quantity:</label>
                                <Quantity
                                    id={`msc-cart-line__quantity_${product.RecordId}`}
                                    currentCount={carouselCurrQuantity}
                                    onChange={onQChangeNewCarouselDesign}
                                    hideQuantityControls={false}
                                    disabledInput={false}
                                    max={context.app.config.maxQuantityForCartLineItem}
                                    min={1}
                                />
                            </div>
                        )}

                        {saveForLaterHandler ? (
                            <>
                                <div className='msc-cart__save-for-later-cta'>
                                    <Button
                                        onClick={() => {
                                            if (moveToBasket) {
                                                moveToBasket(product);
                                            }
                                        }}
                                    >
                                        Move to basket
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            if (removeProductFromCollection) {
                                                removeProductFromCollection(product.RecordId);
                                            }
                                        }}
                                    >
                                        Remove
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                    {isUnbxdWidget &&
                        renderPrice(
                            context,
                            typeName,
                            id,
                            checkUserLoyalty && membershipDiscount ? product.BasePrice : nonClubPlusDiscount?.AdjustedPrice!,
                            checkUserLoyalty && membershipDiscount ? product.Price : nonClubPlusDiscount?.CustomerContextualPrice!,
                            savingsText,
                            freePriceText,
                            originalPriceText,
                            currentPriceText,
                            checkUserLoyalty && membershipDiscount ? discountLine : nonClubPlusDiscount?.DiscountLines,
                            cartData,
                            updatedProductPrice,
                            getTierId,
                            checkClubPlusDiscounts
                        )}
                    {checkClubPlusDiscounts && checkUserLoyalty && (
                        <div className='product-card-club-plus-discount product-card-club-plus product-card-club-plus'>
                            <p>Club Plus price</p>
                            <p className='product-card-club-plus-price'>£{product.Price.toFixed(2)}</p>
                        </div>
                    )}
                    {checkClubPlusDiscounts && checkUserLoyalty === undefined && (
                        <div
                            className={
                                product.clubPlusBanner ? 'product-card-club-plus-badge badge-collapse-pdp' : 'product-card-club-plus-badge'
                            }
                        >
                            {product.clubPlusBanner && (
                                <div className='product-club-plus-container-info'>
                                    <div
                                        onClick={() => hideBanner && hideBanner(product.RecordId)}
                                        className='product-card-club-plus-cross'
                                    ></div>
                                    <p className='product-club-plus-info'>
                                        {/* Join Dobbies Club Plus for just £12 a year and enjoy 10% off on plants, bulbs and Seeds.{' '} */}
                                        Join Club Plus and save 10% on plants, bulbs and seeds all year round
                                        <span>
                                            {' '}
                                            <a href={badgeLink ? badgeLink : ''}>Find out more</a>
                                        </span>
                                    </p>
                                </div>
                            )}
                            <div className='product-card-club-plus'>
                                <p>Club Plus price</p>
                                <p className='product-card-club-plus-price'>£{product.Price.toFixed(2)}</p>
                                <div onClick={() => showBanner && showBanner(product.RecordId)} className='product-card-club-plus-icon'>
                                    <p>?</p>
                                </div>
                            </div>
                        </div>
                    )}
                    {isNewCarouselDesign && !existsInCartLines ? (
                        <Button
                            className='ms-wishlist-items__product-add-button'
                            title={'Add to cart'}
                            onClick={() => {
                                addProductToCartNewCarousel();
                            }}
                        >
                            Add
                        </Button>
                    ) : (
                        <></>
                    )}
                    {isUnbxdWidget && showUnbxdAddToBasket && !isFetchingInventory && (
                        <Button
                            className={`to-link ${existsInCartLines ? 'added' : ''} ${!isProductAvailable ? 'out-of-stock' : ''}`}
                            title={existsInCartLines ? 'Added to Basket' : 'Add to Basket'}
                            disabled={!isProductAvailable || existsInCartLines || isAddingToBasket}
                            onClick={() => {
                                addProductToCartNewCarousel();
                            }}
                        >
                            {isAddingToBasket ? 'Adding to Basket...' : existsInCartLines ? 'Added to Basket' : 'Add to Basket'}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
};

function getProductName(product: IProductWithModes | undefined, productName: string): string | undefined {
    let prodName = '';
    //debugger;
    if ((product && product.AttributeValues === undefined) || (product && product.AttributeValues?.length == 0)) {
        prodName = productName;
    } else {
        if (product && product.AttributeValues) {
            product.AttributeValues?.map((val: AttributeValue) => {
                if (val.Name === 'EComName' && val.TextValue !== '') {
                    prodName = val.TextValue!;
                } else {
                    prodName = productName;
                }
            });
        }
    }
    return prodName;
}

function renderLabel(name?: string, price?: string, rating?: number, ratingAriaLabel?: string): string {
    name = name || '';
    price = price || '';
    return `${name} ${price} ${getRatingAriaLabel(rating, ratingAriaLabel)}`;
}

// function renderDescription(description?: string): JSX.Element | null {
//     return <p className='msc-product__text'>{description}</p>;
// }

function getRatingAriaLabel(rating?: number, ratingAriaLabel?: string): string {
    if (rating && ratingAriaLabel) {
        const roundedRating = rating.toFixed(2);
        return format(ratingAriaLabel || '', roundedRating, '5');
    }
    return '';
}

function updateProductUrl(productUrl: string, context: ICoreContext): string {
    const srcUrl = new URL(productUrl, context.request.apiSettings.baseUrl);
    const queryString = `back=true`;
    if (srcUrl.search) {
        srcUrl.search += `&${queryString}`;
    } else {
        srcUrl.search += queryString;
    }

    const updatedUrl = new URL(srcUrl.href);
    return updatedUrl.pathname + srcUrl.search;
}

function renderRating(
    context: ICoreContext<{
        [x: string]: any;
    }>,
    typeName: string,
    id: string,
    avgRating?: number,
    totalRatings?: number,
    ariaLabel?: string
): JSX.Element | null {
    if (!avgRating) {
        return null;
        // display empty box to match the design of when rating isnt there on product component
    }

    const minNumOfStars = context.app.config.numberOfStarReviewsToShow;
    if (minNumOfStars && avgRating && avgRating < minNumOfStars) {
        return <></>;
    }

    const numRatings = (totalRatings && totalRatings.toString()) || undefined;
    const ratingAriaLabel = getRatingAriaLabel(avgRating, ariaLabel);

    return (
        <RatingComponent
            context={context}
            id={id}
            typeName={typeName}
            avgRating={avgRating}
            ratingCount={numRatings}
            readOnly={true}
            ariaLabel={ratingAriaLabel}
            data={{}}
        />
    );
}

function renderPrice(
    context: ICoreContext,
    typeName: string,
    id: string,
    basePrice?: number,
    adjustedPrice?: number,
    savingsText?: string,
    freePriceText?: string,
    originalPriceText?: string,
    currentPriceText?: string,
    discountLine?: DiscountLine[] | undefined,
    cartData?: Cart | undefined,
    updatedPrice?: number,
    getTierId?: () => number | undefined,
    clubPlusDiscountsOfferId?: DiscountLine | undefined | false
): JSX.Element | null {
    const price: ProductPrice = {
        BasePrice: basePrice,
        AdjustedPrice: adjustedPrice,
        CustomerContextualPrice: adjustedPrice
    };

    return (
        <PriceComponent
            context={context}
            id={id}
            typeName={typeName}
            data={{ price: price }}
            savingsText={savingsText}
            freePriceText={freePriceText}
            originalPriceText={originalPriceText}
            discountLine={discountLine}
            cartData={cartData}
            updatedPrice={updatedPrice}
            getTierId={getTierId}
            clubPlusDiscountsOfferId={clubPlusDiscountsOfferId}
        />
    );
}

//VSI CUSTOMIZATION -START - Task 11167: PLP hover image flip
async function validateSingleImageAsync(uri: string): Promise<IImageData | null> {
    if (!uri) {
        return null;
    }
    return new Promise<IImageData | null>(resolve => {
        try {
            const http = new XMLHttpRequest();
            http.open('HEAD', uri, true);
            http.addEventListener('load', () => {
                if (http.status === 200 || http.status === 201) {
                    resolve({ src: uri, altText: '' });
                } else {
                    resolve(null);
                }
            });
            http.addEventListener('error', () => {
                resolve(null);
            });
            http.send();
        } catch {
            resolve(null);
        }
    });
}

async function validateMediaLocaionAsync(uris: string[]): Promise<IImageData[]> {
    const validationPromises = uris.map(uri => validateSingleImageAsync(uri));
    const results = await Promise.all(validationPromises);
    return results.filter((img): img is IImageData => img !== null);
}
//VSI CUSTOMIZATION -END - Task 11167: PLP hover image flip
function renderProductPlacementImage(
    imageSettings?: IImageSettings,
    gridSettings?: IGridSettings,
    imageUrl?: string,
    altText?: string,
    apiSettings?: ICommerceApiSettings,
    product?: IProductWithModes
): JSX.Element | null {
    if (!imageUrl || !gridSettings || !imageSettings || !apiSettings) {
        return null;
    }

    let newImageUrl = generateImageUrl(imageUrl, apiSettings);
    // Handle encoded forward slashes
    if (newImageUrl?.includes('%2F')) {
        newImageUrl = newImageUrl.replace(/%2F/g, '/');
    }

    if (newImageUrl) {
        const sanitizedUrl = sanitizeImageUrl(newImageUrl);
        newImageUrl = getOptimizedImageUrl(sanitizedUrl, 250);
    }

    const img: IImageData = {
        src:
            newImageUrl && product?.ItemId && newImageUrl.includes(product?.ItemId)
                ? newImageUrl
                : newImageUrl && !product?.ItemId
                ? newImageUrl
                : '',
        altText: altText ? altText : ''
    };

    const imageProps = {
        gridSettings: gridSettings
    };

    // debugger;
    return <Image {...img} {...imageProps} loadFailureBehavior='empty' key={imageUrl} />;
}

// @ts-ignore
export const ProductComponent: React.FunctionComponent<IProductComponentProps> = msdyn365Commerce.createComponentOverride<
    IProductComponent
>('Product', { component: ProductCard, ...PriceComponentActions });

export default ProductComponent;
